'use client';
import { CheckIcon, Copy } from 'lucide-react';


import { cn } from '@/shared/utils/utils';
import { Button, ButtonProps } from '@nextui-org/react';
import { ReactNode, useEffect, useState } from 'react';

interface CopyButtonProps extends ButtonProps {
  value: string;
  src?: string;
  event?: Event;
  children?: ReactNode;
}

export async function copyToClipboardWithMeta(value: string, _event?: Event) {
  navigator.clipboard.writeText(value);
}

export function CopyButton({
  value,
  className,
  src: _src,
  variant: _variant = 'ghost',
  event: _event,
  children,
  ...props
}: CopyButtonProps) {
  const [hasCopied, setHasCopied] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setHasCopied(false);
    }, 3000);
    return () => clearTimeout(id);
  }, [hasCopied]);

  return (
    <Button
      isIconOnly
      variant="light"
      size="sm"
      className={cn('', className)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setHasCopied(true);
        copyToClipboardWithMeta(value);
      }}
      {...props}
    >
      <span className="sr-only">Copy</span>
      {children}
      {hasCopied ? <CheckIcon size={16} /> : <Copy size={16} />}
    </Button>
  );
}
